import { axiosExpressionInstance } from './http-common'

class NamedValuesService {
  async listNamedValues(organization: string, page: number, size: number, name?: string, value?: string) {
    return (
      await axiosExpressionInstance.get(`${organization}/named-values`, {
        params: {
          page: page,
          size: size,
          name: name,
          value,
        },
        paramsSerializer: { indexes: null },
      })
    ).data
  }

  addNamedValue = async (
    organization: string,
    body: {
      name: string
      value: string
    },
  ): Promise<any> => {
    return (await axiosExpressionInstance.post(`/${organization}/named-values`, body)).data
  }

  async deleteNamedValue(organization: string, id: string) {
    return (await axiosExpressionInstance.delete(`/${organization}/named-values/${id}`)).data
  }

  async updateName(organization: string, name: string, oldName: string) {
    return (await axiosExpressionInstance.put(`/${organization}/named-values/name`, { oldName: oldName, name: name }))
      .data
  }

  async updateValue(organization: string, name: string, value: string) {
    return (await axiosExpressionInstance.put(`/${organization}/named-values/value`, { value: value, name: name })).data
  }
}

export default new NamedValuesService()
